import type { FC } from 'react';
import { MenuItem, Select, Typography } from '@mui/material';

import type {
  Filter,
  WidgetFilterConfig,
} from 'src/components/dashboard/hooks/useWidgetFilterConfig';

import { styles } from './index.styles';

interface FilterProps {
  filterConfig: WidgetFilterConfig;
  setFilters: (filter: Filter) => void;
  maxWidth?: string;
  selectedFilters: Filter;
}

const FilterDropdown: FC<FilterProps> = ({
  setFilters,
  selectedFilters,
  maxWidth = '20rem',
  filterConfig,
}) => {
  const onChange = (value: string) => {
    setFilters({ [filterConfig.filterName]: value });
  };

  return (
    <Select
      aria-label={`Filter by ${filterConfig.filterName}`}
      value={selectedFilters[filterConfig.filterName]}
      onChange={(event) => onChange(event.target.value)}
      fullWidth
      sx={styles.filterSelect(maxWidth)}
      MenuProps={{
        PaperProps: {
          sx: styles.filterPaper,
        },
      }}
    >
      {filterConfig.values.map(({ value, label }) => (
        <MenuItem value={value} key={value} sx={styles.filterMenuItem}>
          <Typography variant="button2">{label}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
};

export default FilterDropdown;
